'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  domain: null,
  isResolving: false,
  isSslEnabled: false
};

var CustomHostedDomain = function (_Record) {
  _inherits(CustomHostedDomain, _Record);

  function CustomHostedDomain() {
    _classCallCheck(this, CustomHostedDomain);

    return _possibleConstructorReturn(this, (CustomHostedDomain.__proto__ || Object.getPrototypeOf(CustomHostedDomain)).apply(this, arguments));
  }

  _createClass(CustomHostedDomain, null, [{
    key: 'from',
    value: function from(json) {
      if (json) {
        return new CustomHostedDomain({
          domain: json.domain,
          isResolving: json.isResolving,
          isSslEnabled: json.isSslEnabled
        });
      }

      return new CustomHostedDomain();
    }
  }]);

  return CustomHostedDomain;
}((0, _Immutable.Record)(defaults));

exports.default = CustomHostedDomain;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/CustomHostedDomain.js
// module id = 324
// module chunks = 0